import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";

import store from "./redux/store";

import ROUTER from "./constants/router";

import AppLayout from "./components/AppLayout";
import Login from "./containers/AppLayout/Login";

import "./index.css";
import theme from "./theme";

function App({ instance }) {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <Switch>
            <Route exact path={ROUTER.LOGIN} component={Login} />
            <Route path={ROUTER.HOME} component={AppLayout} />
          </Switch>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;

